import { useTranslation } from 'react-i18next';
import { LoginWraper } from '@/components/login';
import { RegistrationForm } from '@/containers/pages/register/components/RegistrationForm';
import { defaultMailServerPasswordOptions } from '@/mock-data/passwordOptions';
import { useAppSelector } from '@hooks/redux/redux';
import { useEffect } from 'react';
import i18n from '@/entities/i18next';

export const Register = () => {
  const { t } = useTranslation();
  const { Settings } = useAppSelector((state) => state.userInfo);

  // Initialize locale from global settings for unauthenticated users
  useEffect(() => {
    const localLanguage = localStorage.getItem('lng');
    if (Settings?.Culture && Settings.Culture !== localLanguage) {
      localStorage.setItem('lng', Settings.Culture);
      i18n.changeLanguage(Settings.Culture);
    }
  }, [Settings?.Culture]);

  return (
    <LoginWraper title={t('register.title')} text={t('')}>
      <RegistrationForm passwordStrengthOptions={defaultMailServerPasswordOptions} />
    </LoginWraper>
  );
};
